import EFPicture from '@elem/compCommon/EFPicture';
import styles from './h5.module.scss';

const H5: React.FC = () => {
    return (
        <div className={styles.h5}>
            <div className="sec sec-1">
                <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745484397033/Frame%201612707427%20(1).jpg" />
                <div className="text">
                    <div className="title">
                        <span className="bold">2000Wh</span>大容量
                    </div>
                    <div className="plus">+</div>
                    <div className="desc">最大6kWhに容量拡張</div>
                </div>
            </div>
            <div className="sec-2">
                <div className="sec sec-2-l">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476192211/Group%20211863%20-h5.jpg" />
                    <div className="text">
                        <div className="title">10年長寿命</div>
                        <div className="desc">LFPバッテリー採用</div>
                    </div>
                </div>
                <div className="sec sec-2-r">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476245782/Group%20211864%20-h5.jpg" />
                    <div className="text">高品質・BMS・堅牢設計</div>
                </div>
            </div>

            <div className="sec sec-3">
                <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745478540684/Frame%20128720596%20-h5.jpg" />
                <div className="text">
                    <div className="title">最大2400W</div>
                    <div className="desc">の家電を稼働可能</div>
                </div>
            </div>
            <div className="sec-4">
                <div className="sec sec-4-l">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476642155/02-9-bg%403x-h5.jpg" />
                    <div className="text">
                        スマホアプリで <br />
                        誰でも簡単操作
                    </div>
                </div>
                <div className="sec sec-4-r">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476580455/Frame%20211878-h5.jpg" />
                    <div className="text">
                        <div className="title">{'<20ms自動電源'}</div>
                        <div className="desc">切り替え機能</div>
                    </div>
                </div>
            </div>
            <div className="sec-5">
                <div className="sec-5-l">
                    <div className="sec sec-5-l-t">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476146136/Group%20212152%20-h5.jpg" />
                        <div className="text nowrap">
                            充実の15出力ポート　
                            <br />
                            複数機器を
                            <br />
                            同時給電 & 充電
                        </div>
                    </div>
                    <div className="sec sec-5-l-b">
                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476723200/Group%20212151%20-h5.jpg" />
                        <div className="text">
                            排気ガス/騒音フリー & <br />
                            簡単メンテナンス
                        </div>
                    </div>
                </div>
                <div className="sec sec-5-r">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745476461207/Group%201612706690-h5.jpg" />
                    <div className="text">シーンに合わせた 4つの急速充電</div>
                </div>
            </div>
        </div>
    );
};

export default H5;
